import AcaoButtons from "../../Shared/AcaoButtons";

// Etapas sem campos próprios (ex.: aprovações simples, confirmações de lançamento) —
// só mostra as ações disponíveis vindas do backend.
export default function EtapaSomenteAcoes({ acoes = [], acaoEmExecucao, onExecutarAcao, texto }) {
    return (
        <div className="flex flex-col gap-4">
            {texto && <p className="text-sm text-muted-foreground">{texto}</p>}
            <div className="flex justify-end">
                <AcaoButtons acoes={acoes} acaoEmExecucao={acaoEmExecucao} onAcao={onExecutarAcao} />
            </div>
        </div>
    );
}
